<template lang="html">
  <div class="bill-table-wrapper" v-loading="tableLoading">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed="left"  align="center" prop="status" label="操作">
        <template slot-scope="scope">
          <span class="link-url" @click="goDetail(scope.row)">详情</span>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" label="账单号" align="center">
      </el-table-column>
      <el-table-column prop="realTotalMoney" label="金额" align="center">
      </el-table-column>
      <el-table-column
        prop="receiptAndPaymentStatus"
        label="状态"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="" label="时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime | timeFormat }}
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :hide-on-single-page="true"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      tableLoading: true
    };
  },
  computed: {
    isNewBill() {
      return this.ruleForm.billType === 1;
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    /**
     * [getDataList description]
     * @param  {[type]}  type === true [表示是父组件调用]
     * @param  {[type]}  type === false [表示当前组件调用]
     */
    async getDataList(type) {
      type && (this.page = 1);
      this.tableLoading = true;
      let {
        createTime,
        realTotalMoney,
        receiptAndPaymentStatus
      } = this.ruleForm;
      let searchData = this.$clearEmptyParams({
        realTotalMoney,
        createTime
      });
      let bool = !!Object.keys(searchData).length;
      let {
        data: { list, count }
      } = await this.$http.get(
        `/shipper/order-shipper/${
          this.isNewBill ? "bill-list" : "former-bill-list"
        }`,
        {
          params: {
            page: this.page,
            searchData: {
              receiptAndPaymentStatus,
              ...(bool && searchData)
            }
          }
        }
      );
      this.tableData = list;
      this.total = count;
      this.tableLoading = false;
    },
    currentChange(val) {
      this.page = val;
      this.getDataList();
    },
    goDetail(val) {
      this.$router.push({
        name: "billDetail",
        params: { billNo: val.billNo },
        ...(!this.isNewBill && { query: { isOld: 1 } })
      });
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.bill-table-wrapper {
  min-height: calc(100vh - 490px);
  .table-page-wrapper {
    padding-top: 14px;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/bill/components/billTable/index.vue